import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaBriefcase, FaGem, FaCar, FaUser, FaIndustry, FaCheckCircle, FaFileAlt, FaUserCheck, FaChartLine, FaShieldAlt, FaMoneyBillWave, FaMotorcycle, FaCertificate, FaHome, FaAddressCard, FaUniversity, FaMoneyCheckAlt } from 'react-icons/fa';
import { MdTrendingUp, MdAccountBalance, MdBusiness, MdSecurity, MdDirectionsCar, MdSpeed, MdFactory, MdAssignment, MdAccountBalanceWallet } from 'react-icons/md';

const Loans = () => {
    const { t } = useTranslation();

    const loans = [

        {
            id: 'gold-loan',
            title: t('loans.types.gold.title'),
            subtitle: t('loans.types.gold.desc'),
            description: t('goldLoan.hero.description'),
            icon: <FaGem className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('goldLoan.features.amount'), desc: t('goldLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('goldLoan.features.interestRate'), desc: t('goldLoan.features.interestRateDesc') },
                { icon: <FaShieldAlt />, title: t('goldLoan.features.processing'), desc: t('goldLoan.features.processingDesc') }
            ],
            benefits: [
                t('goldLoan.benefits.benefit1'),
                t('goldLoan.benefits.benefit2'),
                t('goldLoan.benefits.benefit3')
            ],
            eligibility: [
                t('goldLoan.eligibility.age'),
                t('goldLoan.eligibility.gold'),
                t('goldLoan.eligibility.ownership')
            ],
            bgGradient: "from-amber-500 to-amber-600"
        },
        {
            id: 'vehicle-loan',
            title: t('loans.types.vehicle.title'),
            subtitle: t('loans.types.vehicle.desc'),
            description: t('vehicleLoan.hero.description'),
            icon: <FaCar className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('vehicleLoan.features.amount'), desc: t('vehicleLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('vehicleLoan.features.interestRate'), desc: t('vehicleLoan.features.interestRateDesc') },
                { icon: <FaCar />, title: t('vehicleLoan.features.tenure'), desc: t('vehicleLoan.features.tenureDesc') }
            ],
            benefits: [
                t('vehicleLoan.benefits.benefit1'),
                t('vehicleLoan.benefits.benefit2'),
                t('vehicleLoan.benefits.benefit3')
            ],
            eligibility: [
                t('vehicleLoan.eligibility.age'),
                t('vehicleLoan.eligibility.income'),
                t('vehicleLoan.eligibility.employment')
            ],
            bgGradient: "from-red-500 to-red-600"
        },
        {
            id: 'personal-loan',
            title: t('personalLoan.title'),
            subtitle: t('personalLoan.subtitle'),
            description: t('personalLoan.hero.description'),
            icon: <FaUser className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('personalLoan.features.amount'), desc: t('personalLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('personalLoan.features.interestRate'), desc: t('personalLoan.features.interestRateDesc') },
                { icon: <MdSpeed />, title: t('personalLoan.features.processing'), desc: t('personalLoan.features.processingDesc') }
            ],
            benefits: [
                t('personalLoan.benefits.benefit1'),
                t('personalLoan.benefits.benefit2'),
                t('personalLoan.benefits.benefit3')
            ],
            eligibility: [
                t('personalLoan.eligibility.age'),
                t('personalLoan.eligibility.income'),
                t('personalLoan.eligibility.employment')
            ],
            bgGradient: "from-teal-500 to-teal-600"
        },

        {
            id: 'property-loan',
            title: t('propertyLoan.title'),
            subtitle: t('propertyLoan.subtitle'),
            description: t('propertyLoan.hero.description'),
            icon: <FaHome className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('propertyLoan.features.amount'), desc: t('propertyLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('propertyLoan.features.interestRate'), desc: t('propertyLoan.features.interestRateDesc') },
                { icon: <FaChartLine />, title: t('propertyLoan.features.tenure'), desc: t('propertyLoan.features.tenureDesc') }
            ],
            benefits: [
                t('propertyLoan.benefits.benefit1'),
                t('propertyLoan.benefits.benefit2'),
                t('propertyLoan.benefits.benefit3')
            ],
            eligibility: [
                t('propertyLoan.eligibility.property'),
                t('propertyLoan.eligibility.income'),
                t('propertyLoan.eligibility.age')
            ],
            bgGradient: "from-indigo-500 to-indigo-600"
        },
        {
            id: 'salary-loan',
            title: t('salaryLoan.title'),
            subtitle: t('salaryLoan.subtitle'),
            description: t('salaryLoan.hero.description'),
            icon: <FaAddressCard className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('salaryLoan.features.amount'), desc: t('salaryLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('salaryLoan.features.interestRate'), desc: t('salaryLoan.features.interestRateDesc') },
                { icon: <MdSpeed />, title: t('salaryLoan.features.processing'), desc: t('salaryLoan.features.processingDesc') }
            ],
            benefits: [
                t('salaryLoan.benefits.benefit1'),
                t('salaryLoan.benefits.benefit2'),
                t('salaryLoan.benefits.benefit3')
            ],
            eligibility: [
                t('salaryLoan.eligibility.employment'),
                t('salaryLoan.eligibility.income'),
                t('salaryLoan.eligibility.age')
            ],
            bgGradient: "from-purple-500 to-purple-600"
        },
        {
            id: 'cash-credit-loan',
            title: t('cashCreditLoan.title'),
            subtitle: t('cashCreditLoan.subtitle'),
            description: t('cashCreditLoan.hero.description'),
            icon: <FaUniversity className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('cashCreditLoan.features.limit'), desc: t('cashCreditLoan.features.limitDesc') },
                { icon: <MdTrendingUp />, title: t('cashCreditLoan.features.interestRate'), desc: t('cashCreditLoan.features.interestRateDesc') },
                { icon: <FaChartLine />, title: t('cashCreditLoan.features.utilization'), desc: t('cashCreditLoan.features.utilizationDesc') }
            ],
            benefits: [
                t('cashCreditLoan.benefits.benefit1'),
                t('cashCreditLoan.benefits.benefit2'),
                t('cashCreditLoan.benefits.benefit3')
            ],
            eligibility: [
                t('cashCreditLoan.eligibility.business'),
                t('cashCreditLoan.eligibility.collateral'),
                t('cashCreditLoan.eligibility.vintage')
            ],
            bgGradient: "from-rose-500 to-rose-600"
        },
        {
            id: 'deposit-loan',
            title: t('depositLoan.title'),
            subtitle: t('depositLoan.subtitle'),
            description: t('depositLoan.hero.description'),
            icon: <FaMoneyCheckAlt className="text-4xl text-white" />,
            features: [
                { icon: <MdAccountBalance />, title: t('depositLoan.features.amount'), desc: t('depositLoan.features.amountDesc') },
                { icon: <MdTrendingUp />, title: t('depositLoan.features.interestRate'), desc: t('depositLoan.features.interestRateDesc') },
                { icon: <MdSpeed />, title: t('depositLoan.features.processing'), desc: t('depositLoan.features.processingDesc') }
            ],
            benefits: [
                t('depositLoan.benefits.benefit1'),
                t('depositLoan.benefits.benefit2'),
                t('depositLoan.benefits.benefit3')
            ],
            eligibility: [
                t('depositLoan.eligibility.deposit'),
                t('depositLoan.eligibility.membership'),
                t('depositLoan.eligibility.ownership')
            ],
            bgGradient: "from-cyan-500 to-cyan-600"
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
            {/* 1. Hero Section - Corporate Style */}
            <section className="relative py-24 bg-gradient-to-r from-slate-900 to-slate-800 text-white overflow-hidden">
                <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
                    <span className="text-secondary font-bold tracking-widest uppercase text-sm mb-4 block">{t('loans.badge')}</span>
                    <h1 className="text-4xl md:text-5xl font-bold mb-6 font-display">{t('loans.title')}</h1>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed">
                        {t('loans.subtitle')}
                    </p>
                </div>
            </section>

            {/* 2. Intro Benefits Grid */}
            <section className="py-16 bg-white relative -mt-10 z-20 mx-4 md:mx-0">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-white p-8 rounded-xl shadow-xl border-t-4 border-secondary text-center">
                            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center text-primary text-3xl mx-auto mb-4">
                                <MdSpeed />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">{t('loans.whyChoose.quick')}</h3>
                            <p className="text-gray-600">{t('loans.whyChoose.quickDesc')}</p>
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-xl border-t-4 border-secondary text-center">
                            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center text-primary text-3xl mx-auto mb-4">
                                <MdTrendingUp />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">{t('loans.whyChoose.lowInterest')}</h3>
                            <p className="text-gray-600">{t('loans.whyChoose.lowInterestDesc')}</p>
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-xl border-t-4 border-secondary text-center">
                            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center text-primary text-3xl mx-auto mb-4">
                                <FaFileAlt />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">{t('loans.whyChoose.minimal')}</h3>
                            <p className="text-gray-600">{t('loans.whyChoose.minimalDesc')}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. Detailed Loans Sections */}
            <div className="space-y-20 py-20">
                {loans.map((loan, index) => (
                    <section
                        key={loan.id}
                        id={loan.id}
                        className={`scroll-mt-24 py-16 md:py-24 ${index % 2 !== 0 ? 'bg-white' : 'bg-gray-50'} ${['gold-loan', 'personal-loan', 'property-loan', 'cash-credit-loan'].includes(loan.id)
                            ? 'my-12 md:my-16 shadow-sm border-y border-gray-100'
                            : ''
                            }`}
                    >
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-center`}>
                                {/* Content Side */}
                                <div className="md:w-1/2">
                                    <h2 className="text-3xl font-bold text-gray-900 mb-4">{loan.title}</h2>
                                    <p className="text-lg text-primary font-medium mb-4">{loan.subtitle}</p>
                                    <p className="text-gray-600 leading-relaxed mb-8">{loan.description}</p>

                                    {/* Key Benefits List */}
                                    <div className="mb-8 p-6 bg-white rounded-xl shadow-sm border border-gray-100">
                                        <h4 className="font-bold text-gray-800 mb-4 uppercase text-xs tracking-wider">{t('loans.keyBenefits')}</h4>
                                        <ul className="space-y-3">
                                            {loan.benefits.map((benefit, i) => (
                                                <li key={i} className="flex items-start">
                                                    <FaCheckCircle className={`text-secondary mt-1 mr-3 flex-shrink-0`} />
                                                    <span className="text-gray-700 text-sm md:text-base">{benefit}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <Link
                                        to={`/contact?service=${encodeURIComponent(loan.title)}`}
                                        className="inline-block px-8 py-3 bg-primary text-white font-bold rounded-lg hover:bg-primary-dark transition-colors duration-300 shadow-md hover:shadow-lg"
                                    >
                                        {t('loans.applyNow')}
                                    </Link>
                                </div>

                                {/* Features Cards Side */}
                                <div className="md:w-1/2 grid grid-cols-1 gap-6">
                                    {loan.features.map((feature, idx) => (
                                        <div key={idx} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border-l-4 border-secondary flex items-start gap-4">
                                            <div className="text-3xl text-primary/80 bg-blue-50 p-2 rounded-lg">
                                                {feature.icon}
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-gray-900 mb-1">{feature.title}</h4>
                                                <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
                                            </div>
                                        </div>
                                    ))}

                                    {/* Mini Eligibility Card */}
                                    <div className="bg-slate-50 p-6 rounded-xl shadow-inner border border-slate-100 mt-4">
                                        <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                                            <FaUserCheck className="text-secondary" />
                                            {t('loans.eligibilityCriteria')}
                                        </h4>
                                        <div className="flex flex-wrap gap-2">
                                            {loan.eligibility.map((item, i) => (
                                                <span key={i} className="bg-white px-3 py-1 rounded-full text-xs font-medium text-gray-600 border border-gray-200">
                                                    {item}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ))}
            </div>

            {/* 4. Common Documentation */}
            <section className="py-20 bg-primary text-white relative overflow-hidden">
                <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold mb-4">{t('loans.documentation.heading')}</h2>
                        <p className="text-blue-100 max-w-2xl mx-auto">{t('loans.documentation.subtitle')}</p>
                    </div>
                    <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/10">
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <li className="flex items-center gap-4">
                                <div className="p-2 bg-secondary/20 rounded-lg"><FaFileAlt className="text-secondary" /></div>
                                <span>{t('loans.documentation.doc1')}</span>
                            </li>
                            <li className="flex items-center gap-4">
                                <div className="p-2 bg-secondary/20 rounded-lg"><FaFileAlt className="text-secondary" /></div>
                                <span>{t('loans.documentation.doc2')}</span>
                            </li>
                            <li className="flex items-center gap-4">
                                <div className="p-2 bg-secondary/20 rounded-lg"><FaFileAlt className="text-secondary" /></div>
                                <span>{t('loans.documentation.doc3')}</span>
                            </li>
                            <li className="flex items-center gap-4">
                                <div className="p-2 bg-secondary/20 rounded-lg"><FaFileAlt className="text-secondary" /></div>
                                <span>{t('loans.documentation.doc4')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Loans;
